"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var props_1 = require("../../../context/props");
var index_1 = require("../../../../index");
var FilterModal = function (props) {
    var onClose = props.onClose;
    var _a = (0, props_1.usePropsContext)(), translate = _a.translate, filter = _a.filter;
    var _b = filter.mobileModalTitle, mobileModalTitle = _b === void 0 ? '' : _b, _c = filter.onFilter, onFilter = _c === void 0 ? function () { } : _c, _d = filter.mobileElement, mobileElement = _d === void 0 ? null : _d, _e = filter.isFullScreenMobileModal, isFullScreenMobileModal = _e === void 0 ? false : _e, _f = filter.maxWidthMobileModal, maxWidthMobileModal = _f === void 0 ? 'md' : _f;
    var handlerSave = (0, react_1.useCallback)(function () {
        onClose();
        onFilter();
    }, [onClose, onFilter]);
    return (react_1.default.createElement(index_1.ModalDialog, { open: true, onClose: onClose, onOk: handlerSave, title: mobileModalTitle, labelOk: translate('save', 'Save'), labelCancel: translate('cancel', 'Cancel'), fullScreen: isFullScreenMobileModal, fullWidth: true, maxWidth: maxWidthMobileModal }, mobileElement));
};
exports.default = FilterModal;
